import {
  BT_NEWSLETTERS,
  NEWSLETTER_TYPE,
} from "@components/Newsletter/types/Newsletter";
import NewsletterForm from "@features/newsletter/components/NewsletterForm";
import { cn } from "@util/helpers";

/**
 * The form component for the Decoding Asia newsletter.
 * @figma https://www.figma.com/design/9O7z95a6ncgr3kFoOqJP7Q/BT-GLOBAL?node-id=18725-33992&m=dev
 */
const Form = (): React.ReactElement => {
  const decodingAsiaNewsletter = BT_NEWSLETTERS.filter(
    ({ type }) => type === NEWSLETTER_TYPE.BTGLOBAL
  );

  return (
    <div
      data-testid="form-component"
      className="track-impression w-full lg:mb-6 lg:w-3/4 xl:w-2/3"
      data-section-name="newsletter"
      data-section-label="decoding asia"
    >
      <NewsletterForm
        newsletters={decodingAsiaNewsletter}
        formClassName={cn("grid grid-cols-1 gap-3")}
        inputClassName={cn(
          "border border-blue-100 rounded-full px-4 py-3 font-poppins font-normal leading-5 text-sm text-gray-850 transition-colors",
          "focus:border-verticals-btblue hover:border-verticals-btblue placeholder:text-blue-170"
        )}
        buttonClassName={cn(
          "rounded-full px-4 py-3 font-poppins font-semibold leading-5 text-xs bg-verticals-btblue w-full text-white border-none"
        )}
        isBordered={false}
      />
    </div>
  );
};

export default Form;
